import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CSicakSuSistemi = (props) => {
  const history = useHistory();

  return (
    <div style={{}} className="main-d-vrf">
      <section style={{ width: "100%", height: "100%" }}>
        <button
          style={{
            backgroundColor: "rgb(237, 188, 69)",
            color: "rgb(24, 24, 24)",
            padding: "30px",
            fontSize: "20px",
            fontWeight: 600,
            maxHeight: "100px",
            width: "240px",
            border: '3px solid "rgb(67, 51, 22)"',
            borderRadius: "20px",
            marginLeft: "42%",
            marginTop: "4%",
          }}
        >
          SICAK SU SİSTEMİ
        </button>
        <div
          style={{
            width: "95%",
            height: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            padding: "0 4% ",
          }}
          className="btn-group"
        >
          {/* <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "240px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // black'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/boyler-odalar");
            }}
          >
            Boyler Odalar
          </button>

          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "240px",
              transition: "0.3s",

              ":hover": {
                backgroundColor: "black",
              },
            }}
            onClick={() => {
              history.push("/boyler-alt-zone");
            }}
          >
            Boyler Alt Zone
          </button> */}

{props.pages.map((x => {
            if (x.group === "Sıcak Su Sistemi") {
              return (
                <button
                  style={{
                    backgroundColor: "rgb(237, 188, 69)",
                    color: "rgb(45, 45, 45)",
                    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "3px solid rgb(67, 51, 22)",
                    borderRadius: "16px",
                    padding: "10px",
                    fontSize: "19px",
                    fontWeight: "600",
                    cursor: "pointer",
                    outline: "none",
                    appearance: "none",
                    userSelect: "none",
                    maxHeight: "120px",
                    width: "240px",
                    transition: "0.3s",

                    ":hover": {
                      backgroundColor: "black",
                    },
                  }}
                  onClick={() => {
                    function normalizeURLPath(path) {
                      const turkishMap = {
                          'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                          'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                          'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                      };
                  
                      return path.split('').map(char => turkishMap[char] || char).join('');
                  }
                  
                  let pathName = normalizeURLPath(x.pageName);
                    history.push("/pages/"+pathName.replaceAll(" ","_"));
                  }}
                >
                  {x.pageName.toUpperCase()}
                </button>
              )
            }
          }))}
        </div>
      </section>
    </div>
  );
};

const MapStateToProps = (state)=>{
  return{
    pages:state.project_reducer.pages
  }
}
export default connect(MapStateToProps)(CSicakSuSistemi);
